import { ReactNode } from "react";

/**
 * FramedSection, simplified wrapper.
 *
 * Originally drew dashed safe-area lines, `+` crosshair marks, hatch
 * bands and faint background patterns sitewide. The brand has moved to a
 * cleaner, modern look (see `WhatManeCanDo`), so this component now
 * renders nothing but a centered max-width column. All decorative props
 * are accepted but no-op to keep call sites identical.
 */
interface FramedSectionProps {
  children: ReactNode;
  noTop?: boolean;
  noBottom?: boolean;
  hatchBands?: boolean;
  pattern?: "noise" | "hatch" | "grid" | "dots" | "waves";
  gradient?: boolean;
  className?: string;
  id?: string;
  /**
   * Background tone for the full-bleed section band. "default" keeps the
   * page background; "muted" paints a slightly darker greyish shade so
   * consecutive sections alternate as the user scrolls.
   */
  tone?: "default" | "muted";
}

const FramedSection = ({ children, className, id, tone = "default" }: FramedSectionProps) => (
  <section
    id={id}
    className={[
      "relative w-full",
      tone === "muted" ? "bg-muted/60 dark:bg-muted/40" : "",
      className,
    ]
      .filter(Boolean)
      .join(" ")}
  >
    <div className="relative max-w-[1280px] mx-auto px-0 md:px-8">{children}</div>
  </section>
);


export default FramedSection;
